/**
 * Sentry environment tag — mirrors back `config.sentry.environment`
 * (`serverHost` with `.ommnio.com` stripped at deploy time).
 */
export function getSentryEnvironment() {
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }

  const domain = process.env.APP_DOMAIN || '';
  if (!domain) {
    return 'production';
  }

  return domain.replace(/\.ommnio\.com$/, '') || 'production';
}
